import { createFileRoute, retainSearchParams } from "@tanstack/react-router"

import WorkInProgressAlert from "@/components/common/Alerts/WorkInProgressAlert"

export const Route = createFileRoute("/app/dashboard/_layout/pending-approvals/_layout/source-change")({
  search: {
    middlewares: [retainSearchParams(["taskViewScope"])],
  },
  component: () => <WorkInProgressAlert />,
})
